export default __webpack_public_path__ + "static/media/Pretendard-Light.27c9a07c.woff2";